import { render, staticRenderFns } from "./Centers.vue?vue&type=template&id=21c2025e&scoped=true&"
import script from "./Centers.vue?vue&type=script&lang=ts&"
export * from "./Centers.vue?vue&type=script&lang=ts&"
import style0 from "./Centers.vue?vue&type=style&index=0&id=21c2025e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c2025e",
  null
  
)

export default component.exports